import { isIOS } from "../../utils/isIOS";

export const scrollPageTo = (value: number) => {
  if (isIOS()) {
    window.scrollTo({
      top: value
    });
  } else {
    window.scrollTo({
      top: value,
      behavior: "smooth"
    });
  }
};
